document.addEventListener("DOMContentLoaded", function () {
  const banner = document.getElementById("gift-banner");
  const tab = document.getElementById("gift-banner-tab");
  const tab_mobile = document.getElementById("gift-banner-tab-mobile");
  const close = banner.querySelector(".gift-banner-close");

  if (!banner) return;

  tab.addEventListener("click", function () {
    banner.classList.add("active");
  });

  if (tab_mobile) {
    tab_mobile.addEventListener("click", function () {
      banner.classList.add("active");
    });
  }

  close.addEventListener("click", function () {
    banner.classList.remove("active");
  });

  document.addEventListener("click", function (e) {
    const isClickInside = banner.contains(e.target);
    let isTabClick = tab.contains(e.target);
    if (tab_mobile) {
      isTabClick = tab_mobile.contains(e.target);
    }
    if (!isClickInside && !isTabClick) {
      banner.classList.remove("active");
    }
  });
});
